import { notification } from "antd";
import { registerAlertFunction } from "../utils/notificationService";
import { useEffect } from "react";

const NotificationProvider = () => {
  useEffect(() => {
    registerAlertFunction(({ message, type, title, placement = "topRight" }) => {
      notification[type]({
        message: title || type.toUpperCase(),
        description: message,
        placement: placement,
        duration: 5,
      });
    });
  }, []);

  return null;
};

export default NotificationProvider;